import { usePagamentoListar, usePagamentoListarPorTitulo } from "@/Services/Financeiro/Titulo/Pagamento/PagamentoServices";
import { List, ListProps } from "antd";
import PagamentoListItem, { IPagamentoListItemProps } from "./PagamentoListItem";
import Pagamento from "@/Models/Financeiro/Titulo/Pagamento/Pagamento";
export interface ITituloPagamentoListProps extends ListProps<Pagamento> {
    codTitulo : number;
    propsItem?: Omit<IPagamentoListItemProps, "data"|"avatar"> & {
        avatar? : (pagamento : Pagamento) => React.ReactNode;  
    };
}
export default function TituloPagamentoList({
    codTitulo,
    propsItem,
    ...rest
}:ITituloPagamentoListProps) {
    const {
        data, 
        isLoading,
        isFetching
    } = usePagamentoListar({
        codTitulo : codTitulo
    });
    
    return <List
        dataSource={data ?? []}
        loading={isLoading || isFetching}
        bordered={rest?.bordered === undefined ? true : rest?.bordered}
        renderItem={(pagamento) => <PagamentoListItem 
                {...propsItem}
                data={pagamento} 
                avatar={propsItem?.avatar?.(pagamento)} 
            />
        }
    />
}

export function TituloPagamentoListPorTitulo({
    codTitulo,
    propsItem,
    ...rest
}:ITituloPagamentoListProps) {
    const {
        data, 
        isLoading,
        isFetching
    } = usePagamentoListarPorTitulo({
        codTitulo : codTitulo
    });
    
    return <List
        dataSource={data ?? []}
        loading={isLoading || isFetching}
        bordered={rest?.bordered === undefined ? true : rest?.bordered}
        renderItem={(pagamento) => <PagamentoListItem 
                {...propsItem}
                data={pagamento} 
                avatar={propsItem?.avatar?.(pagamento)} 
            />
        }
    />
}